import React from 'react';
import { Route, Switch } from 'react-router';
import CreateProgram from './create';
import EditProgram from './edit';

const Programs = () => {
  return (
    <Switch>
      <Route
        exact
        path='/admin/districts/:districtId/programs/new/'
        component={CreateProgram}
      />
      <Route
        exact
        path='/admin/districts/:districtId/programs/:id'
        component={EditProgram}
      />
    </Switch>
  );
};

export default Programs;
